import React from 'react';

import { AlertCircleIcon } from 'src/components/icons';
import { useAppDispatch } from 'src/hooks/useStore';
import { AlertModal } from 'src/legacy/components/Modals';
import { useDeleteAppBuilderMutation } from 'src/services/api/appBuilderApi';
import { alertSnackbar } from 'src/store/ui/actions';

interface DeleteAppBuilderModalProps {
  appId: string;
  appName: string;
  onClose: () => void;
  onDeleted?: () => Promise<void> | void;
}

export const DeleteAppBuilderModal: React.FC<DeleteAppBuilderModalProps> = ({
  appId,
  appName,
  onClose,
  onDeleted,
}) => {
  const dispatch = useAppDispatch();
  const [deleteBuilder, { isLoading }] = useDeleteAppBuilderMutation();

  const handleConfirm = async () => {
    try {
      await deleteBuilder({ id: appId }).unwrap();
      await onDeleted?.();
      onClose();
    } catch (error) {
      console.error(error);
      void dispatch(alertSnackbar({ errorMessage: 'Unable to delete app' }));
    }
  };

  return (
    <AlertModal
      open
      title={`Delete app "${appName}"?`}
      successButtonLabel="Delete"
      cancelButtonLabel="Cancel"
      onSuccess={() => void handleConfirm()}
      onClose={onClose}
      noCancelButton={false}
      Icon={AlertCircleIcon}
      isDeleteModal
      isLoading={isLoading}
    >
      This will <strong className="text-red-500">permanently delete</strong>{' '}
      {appName}. This action cannot be undone. You will not be able to recover{' '}
      your app once it has been deleted.
    </AlertModal>
  );
};
